import { makeSelectDocumentValue } from 'services/documents/selectors';
import { selectPeopleKeyedById } from 'services/people/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

const selectDocumentAssignedUsersList = createDeepEqualSelector(
    [makeSelectDocumentValue('personIds'), selectPeopleKeyedById],
    (personIds, peopleKeyedById) => {
        const assignees = personIds
            .map(
                (personId) =>
                    peopleKeyedById[personId] &&
                    peopleKeyedById[personId].fullName
            )
            .sort()
            .join(', ');

        return assignees;
    }
);

export { selectDocumentAssignedUsersList };
